import React from 'react'
import StipopMessageCoinData from '../../Components/Data/StipopMessageCoinData'

const index = props => {
  return <StipopMessageCoinData />
}

export default index
